import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const { t } = useTranslation('');

  useEffect(() => {
    // Tenta ler o cookie 'cookiesAccepted'
    const cookiesAccepted = Cookies.get('cookiesAccepted');
    if (cookiesAccepted === undefined) { // 'undefined' se o cookie não existe
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    // Define o cookie 'cookiesAccepted' com o valor 'true' e validade de 30 dias
    Cookies.set('cookiesAccepted', 'true', { expires: 30 });
    setShowBanner(false);
    // Habilita funcionalidades que dependem de cookies
    enableCookieBasedFeatures();
  };

  const handleReject = () => {
    // Define o cookie 'cookiesAccepted' com o valor 'false' e validade de 30 dias
    Cookies.set('cookiesAccepted', 'false', { expires: 30 });
    setShowBanner(false);
  };

  // Esta função pode ser usada para habilitar funcionalidades
  // que só devem ser executadas se o usuário aceitar os cookies.
  const enableCookieBasedFeatures = () => {
    // Exemplo: inicializar Google Analytics, Hotjar, etc.
    console.log('Cookies aceitos! Inicializando funcionalidades que dependem de cookies...');
  };

  if (!showBanner) return null;

  return (
    <div className='info-cookies' style={{position: 'fixed', right: 0, bottom: '40px',left: '40px',border: '20px',
      width: '440px',
      backgroundColor: '#f4f4f4',
      boxShadow: '0 -1px 10px 0 #acabab4d',
      padding: '20px',
      zIndex: 1000, }}>
      <div className='cky-notice'>
        <h3 className='cky-title'>🍪 {t('footer.usaCokkies')}</h3>
        <div className='text-cookie-block'>
          <p className='description-cookie'> {t('footer.msgCookies')}<a href='/politica-de-privacidade/'> {t('footer.poliPri')}</a></p>
        </div>
        <div className='cky-notice-btn-wrapper' style={{ marginTop: '20px' }}>
          <button onClick={handleReject} style={{ marginRight: '10px' }} className='rejeitar-todos'>{t('footer.rejectCookies')} </button>
          <button onClick={handleAccept} className='aceitar-todos'>{t('footer.aceptCookies')}</button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;